<template>
  <header class="vr360-app-header vr360-wrap__inner"
          :class="{ 'vr360-app-header--white-text vr360-app-header--half-circle': state === 'profile',
                    'vr360-app-header--white-text vr360-app-header--rect': state === 'editProfile',
                    'vr360-app-header--search-openned': searhInputOpenned }"
          v-if="state !== 'showStream'"          
  >
    <p v-if="!connected" class="vr360-text-caption vr360-text-white vr360-app-header__no-connection">
      <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5 5.5v-3" stroke="#fff" stroke-miterlimit="10" stroke-linecap="round"/><circle cx="5" cy="5" r="4.5" stroke="#fff"/><circle cx="5" cy="7.25" r=".75" fill="#fff"/></svg> 
      <span>No iternet connection</span>
    </p>
    <div class="vr360-app-header__top">
      <left />
      <center />
      <right  @searchBlured="searchBluredHandler"
              @searchFocused="searchFocusedHandler"/>
    </div>

    <div class="vr360-app-header__bottom">
      <tabs v-if="state === 'publicList' || state === 'myList'" />
    </div>

    <!-- <p><button type="button" @click="logout">Logout</button></p> -->
    <!-- <p><router-link :to="{ name: 'Profile' }">Profile</router-link></p> -->
  </header>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import left from "@/components/app/partials/header/LeftHeader";
import center from "@/components/app/partials/header/CenterHeader";
import tabs from "@/components/app/partials/header/TabsHeader";
import right from "@/components/app/partials/header/RightHeader";

export default {
  name: "HeaderList",
  components: {
    left,
    center,
    tabs,
    right
  },
  data() {
    return {
      state: null,
      searhInputOpenned: false
    };
  },
  created() {
    this.checkToShow(this.$route.name);
  },
  methods: {
    ...mapActions({
      logoutUser: "user/logoutUser"
    }),
    logout() {
      this.logoutUser();
    },
    checkToShow(name) {
      switch (name) {
        case "CreateStream":
          this.state = "create";
          break;
        case "EditStream":
          this.state = "edit";
          break;
        case "ListMyStreams":
          this.state = "myList";
          break;
        case "ItemMyStream":
          this.state = "myItem";
          break;
        case "ListPublicStreams":
          this.state = "publicList";
          break;
        case "ItemPublicStream":
          this.state = "publicItem";
          break;
        case "MenuProfile":
          this.state = "profile";
          break;
        case "EditProfile":
          this.state = "editProfile";
          break;
        case "ShowStream":
          this.state = "showStream";
          break;
        default: 
          this.state = null;
          break;
      }
    },
    searchFocusedHandler(value) {
      this.searhInputOpenned = true;
    },
    searchBluredHandler(value) {
      if (!value) {
        this.searhInputOpenned = false;
      }
    }
  },
  watch: {
    $route(to) {
      this.checkToShow(to.name);
    }
  },
  computed: {
    ...mapGetters({
      connected: "connected",
      user: "user/user",
      streamsListScope: "stream/streamsListScope"
    })
  }
};
</script>

<style lang="scss">
</style>
